'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const CardTitleBox = styled(Box)(({theme}) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    fontSize: '1.5rem',
    marginBottom: '0.25rem',
    marginRight: '0.5rem',
    ' .icon' : {
        position: 'relative',
        letterSpacing: 'normal',
        color: theme.palette.custom?.mustard,
        marginRight: '0.5rem'
    }
}));

export default CardTitleBox;
